import { useEffect } from 'react';
import { isProtectedElement } from './protect';

export function usePlayTarget(ref: React.RefObject<HTMLElement>, opts: { reticle?: boolean } = {}) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (isProtectedElement(el)) {
      if (process.env.NODE_ENV !== 'production') console.warn('[mania/play] refusing protected element', el);
      return;
    }
    if (opts.reticle !== false) el.setAttribute('data-play', '');
    return () => el.removeAttribute('data-play');
  }, [ref, opts.reticle]);
}
